"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.createTransaction = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("./utils");
/**
 * Creates an empty transaction.
 *
 * @returns {Transaction}
 */
function createTransaction(_account) {
    return {
        family: "hedera",
        amount: new bignumber_js_1.default(0),
        recipient: "",
        useAllAmount: false,
    };
}
exports.createTransaction = createTransaction;
/**
 * Gather any more neccessary information for a transaction,
 * potentially from a network.
 *
 * Hedera has fully client-side transactions and the fee
 * is not possible to estimate ahead-of-time.
 *
 * @returns  {Transaction}
 */
function prepareTransaction(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
account, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        // explicitly calculate transaction amount to account for `useAllAmount` flag (send max flow)
        // i.e. if `useAllAmount` has been toggled to true, this is where it will update the transaction to reflect that action
        const { amount } = yield (0, utils_1.calculateAmount)({ account, transaction });
        transaction.amount = amount;
        return transaction;
    });
}
exports.prepareTransaction = prepareTransaction;
//# sourceMappingURL=js-transaction.js.map